import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { grid } from '@finect/tabular-utils/grid';
import { getFont } from '@finect/tabular-utils/getFont';
var SectionTitleBlock = styled.div.withConfig({
  displayName: "CenteredTitle__SectionTitleBlock",
  componentId: "sc-j6097m-0"
})(["position:relative;", ";text-align:center;h2{margin-bottom:12px;", ";font-weight:700;", ";", ";}p{", ";color:", ";", ";}", ";"], function (_ref) {
  var maxWidth = _ref.maxWidth;
  return maxWidth && 'max-width: 520px; margin: 0 auto;';
}, getFont(5, 'compact'), maxMediaQueries.miniDesktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      ", ";\n    "])), getFont(4, 'compact')), maxMediaQueries.phone(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", ";\n      ", ";\n    "])), function (_ref2) {
  var margin = _ref2.margin;
  return margin ? "margin: ".concat(margin, ";") : 'margin-bottom: 12px;';
}, getFont(3, 'compact')), getFont(1, 'compact'), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.fontL;
}, maxMediaQueries.phablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      ", ";\n    "])), getFont(0)), maxMediaQueries.phablet(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    width: 100%;\n    max-width: ", "px;\n    margin: 0 auto;\n  "])), grid(4)));
export var CenteredTitle = function CenteredTitle(_ref4) {
  var title = _ref4.title,
    subtitle = _ref4.subtitle,
    noMargin = _ref4.noMargin,
    maxWidth = _ref4.maxWidth;
  return React.createElement(SectionTitleBlock, {
    noMargin: noMargin,
    maxWidth: maxWidth
  }, React.createElement("h2", null, title), React.createElement("p", null, subtitle));
};